import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaTabComponent, CaTabGroupComponent } from '@global-front-components/ui/tabs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BuscarVersionMatriculaComponent } from "../buscar-version-matricula/buscar-version-matricula.component";
import { CaCardComponent } from '@global-front-components/ui/card';
import { AutosBusquedaStoreService } from '../../services/store/autos-busqueda-store.service';
import { Version } from '../../../comun/model/autos.model';
import { RegistroVersion } from './model/tabla-versiones.model';
import { CaTablaSegurosComponent } from '../../../ui/components/tabla-seguros/tabla-seguros.component';
import { ColumnasTabla } from '../../../ui/model/tabla-seguros.model';
import { forkJoin } from 'rxjs';
import { BuscarVersionManualComponent } from '../buscar-version-manual/buscar-version-manual.component';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { CaIcon } from '@global-front-components/ui/form-field';
import { Router } from '@angular/router';
import { RecuperarProyectoComponent } from '../recuperar-proyecto/recuperar-proyecto.component';

@Component({
	selector: 'app-buscador-versiones-modelo',
	standalone: true,
	imports: [
		CommonModule,
		CaTabComponent,
		CaTabGroupComponent,
		CaCardComponent,
		CaTablaSegurosComponent,
		TranslateModule,
		BuscarVersionMatriculaComponent, 
		BuscarVersionManualComponent,
		CaButtonComponent,	
		RecuperarProyectoComponent,
		CaIcon
	],
	templateUrl: './buscador-versiones-modelo.component.html',
	styleUrls: ['./buscador-versiones-modelo.component.scss']
})
export class BuscadorVersionesModeloComponent implements OnInit, OnDestroy {

	@ViewChild(BuscarVersionManualComponent)
	private buscarVersionManualComponent: BuscarVersionManualComponent;
	versiones: Version[];
	registros: RegistroVersion[];
	registrosSeleccionado: RegistroVersion;
	columnas: ColumnasTabla[] = [];

	constructor(
		private autosBusquedaStoreService: AutosBusquedaStoreService,
		private router: Router,		
		private translateService: TranslateService
	) { }

	ngOnInit(): void {
		this.getTraduccionesCabecera();
		this.translateService.get('AUTOS.BUSCADOR_MODELOS.TIPOS_COMBUSTIBLE').subscribe(tiposCombustible => {
			this.autosBusquedaStoreService.versionesSubject$.subscribe((versiones) => {
				if (versiones) {
					this.versiones = versiones;
					this.registros = this.convertirVersionesRegistroTabla(versiones, tiposCombustible);
				}
			});
		});
	}
	
	ngOnDestroy(): void {
		this.autosBusquedaStoreService.limpiarDatos();
		this.buscarVersionManualComponent.irAlPaso(0);
		this.registrosSeleccionado = null;
	}

	private convertirVersionesRegistroTabla(versiones: Version[], tiposCombustible: { [key: string]: string }): RegistroVersion[] {
		return versiones.map(version => {
			const modeloVersion = [version.marca, version.modelo, version.version]
				.filter(val => val && val.trim() !== '')
				.join(' ');

			const combustibleTraducido = tiposCombustible[version.combustible] || tiposCombustible['Otros'];

			return {
				modeloVersion: modeloVersion || '',
				combustible: combustibleTraducido,
				cilindrada: (version.cilindrada + ' cc') || '',
				potencia: (version.potenciaVehi + ' cv') || '',
				nPuertas: version.numPuertas || '',
				anoFabricacion: version.fechaLanz || '',
				marca: version.marca || '',
				modelo: version.modelo || '',
				version: version.version || ''
			};
		});
	}


	private getTraduccionesCabecera(): void {
		forkJoin([
			this.translateService.get('AUTOS.BUSCADOR_MODELOS.TABLA_VERSIONES.MODELO_VERSION'),
			this.translateService.get('AUTOS.BUSCADOR_MODELOS.TABLA_VERSIONES.COMBUSTIBLE'),
			this.translateService.get('AUTOS.BUSCADOR_MODELOS.TABLA_VERSIONES.CILINDRADA'),
			this.translateService.get('AUTOS.BUSCADOR_MODELOS.TABLA_VERSIONES.POTENCIA'),
			this.translateService.get('AUTOS.BUSCADOR_MODELOS.TABLA_VERSIONES.NUMERO_PUERTAS'),
			this.translateService.get('AUTOS.BUSCADOR_MODELOS.TABLA_VERSIONES.ANO_FABRICACION'),
		]).subscribe(translations => {
			this.columnas = [
				{ id: 0, field: 'modeloVersion', value: translations[0] },
				{ id: 1, field: 'combustible', value: translations[1] },
				{ id: 2, field: 'cilindrada', value: translations[2] },
				{ id: 3, field: 'potencia', value: translations[3] },
				{ id: 4, field: 'nPuertas', value: translations[4] },
				{ id: 5, field: 'anoFabricacion', value: translations[5] }
			];
		});
	}

	seleccionarRegistro(registro: RegistroVersion) {
		this.registrosSeleccionado = registro;
	}

	onChangeTab(index: number) {
		this.autosBusquedaStoreService.limpiarMarcas();
		this.autosBusquedaStoreService.limpiarModelos();
		this.autosBusquedaStoreService.limpiarVersiones();
		this.buscarVersionManualComponent.irAlPaso(0);
		this.registrosSeleccionado = null;
	}

	simularPoliza() {
		if (this.registrosSeleccionado) {
			this.versiones.forEach((version) => {
				if (version.marca === this.registrosSeleccionado.marca &&
					version.modelo === this.registrosSeleccionado.modelo &&
					version.version === this.registrosSeleccionado.version) {
					this.autosBusquedaStoreService.setVersionSeleccionada(version);
					this.router.navigate(['/autos/tarificar']);					
				}
			});
		}
	}
}
